import DomainPanel, { Content } from "components/domainPanel/DomainPanel";
import { memo } from "react";
import DomainDetails from "types/domainDetails";

interface AvailableDomainBodyProps {
  domainDetails: DomainDetails;
}

const AvailableDomainBody = (props: AvailableDomainBodyProps) => {
  const { domainDetails } = props;

  const businessIdeaDetails: Content[] | undefined = domainDetails.businessIdeas
    ? domainDetails.businessIdeas.map((i) => {
        return { title: i.title, description: i.description } as Content;
      })
    : undefined;

  return (
    <>
      {businessIdeaDetails && (
        <DomainPanel title={"Business Ideas"} details={businessIdeaDetails} />
      )}
    </>
  );
};

export default memo(AvailableDomainBody);
